<template>
  <v-col cols="12">
    <v-list class="py-0 px-0 pattern-list" dense>
      <v-list-item
        v-for="pattern in patterns"
        :key="pattern.id"
        @click="$emit('editPattern', pattern)"
        class="pattern-element hover-list-element px-2"
        :ripple="false"
      >
        <v-list-item-content>
          <v-row no-gutters style="justify-content: space-between !important;">
            <v-col cols="10" align-self="center">
              <v-list-item-title style="max-width: 20vw">
                <v-row no-gutters class="flex-nowrap">
                  <v-col cols="auto">
                    <v-tooltip bottom color="font" max-width="300">
                      <template #activator="{ on }">
                        <div v-on="on" class="text-body-2 font-weight-regular text-truncate py-0">
                          {{ pattern.name }}
                        </div>
                      </template>
                      <div style="word-break: break-all;">
                        {{ pattern.description }}
                      </div>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-col>
            <v-col cols="auto">
              <dots-menu @delete="$emit('deletePattern', pattern.id)" :items="dotsItems" font-size="19px"></dots-menu>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'ModelingPatternsList',
  components: { DotsMenu },
  props: {
    patterns: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dotsItems: [{ name: 'delete' }],
  }),
};
</script>

<style scoped lang="scss">
.pattern-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.pattern-list {
  border-radius: 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
</style>
